import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlineExtraSmallButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonRaisedButton from "../Common/CommonRaisedButton";
import { RAISED_EXTRA_SMALL_OUTLINE_BUTTONS, RAISED_EXTRA_SMALL_OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/RaisedStyle";

const RaisedOutlineExtraSmallButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={OutlineExtraSmallButton} span={RAISED_EXTRA_SMALL_OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="xs" outline color="primary" id="Tooltip-68" className="btn-pill btn-air-primary">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-68" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-outline-primary btn-xs btn-air-primary</ToolTip>
          {RAISED_EXTRA_SMALL_OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonRaisedButton key={index} item={data} outline size="xs"/>
          ))}
        </CardBody>
      </Card>
    );
};

export default RaisedOutlineExtraSmallButtons;
